// Initial Custom JS File
document.addEventListener('DOMContentLoaded', function() {
    // Add custom JS functionality here
    console.log('Divi child theme custom JS loaded.');
});
